import "../../TabsetTemplate.html";
import "./ConfigurationGroupDetectionEdit.html";
import "./ConfigurationGroupDetectionEdit.scss";

import "../../../../Forms/DaySchedules/DaySchedulesComponent";
import "../../../../Forms/EditInstructionWithContacts/EditInstructionWithContactsComponent";
import "../../../../Forms/HolidaySchedule/HolidayScheduleComponent";
import "../../../../Forms/ScheduleExceptions/ScheduleExceptionsComponent";
import "../../../../Forms/TemporaryWeeklySchedule/TemporaryWeeklyScheduleComponent";
import "../../../../Forms/WeeklySchedule/WeeklyScheduleComponent";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import ConfigurationGroupDetectionEditComponentController from "./ConfigurationGroupDetectionEditComponentController";

export default class ConfigurationGroupDetectionEditComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = ConfigurationGroupDetectionEditComponentController;
        this.templateUrl =
            "/App/Components/Site/ConfigurationGroups/Detection/Edit/ConfigurationGroupDetectionEdit.html";
    }
}

module("mmManagePortal").component("mmConfigurationGroupDetectionEdit", new ConfigurationGroupDetectionEditComponent());
